export default __webpack_public_path__ + "static/media/service.457efb03.svg";